import { getEnv } from 'helpers/common'

interface IReachGoalProps {
  goal: string
  params?: Record<string | number, unknown>
}

export const ymClosure = () => null

const VITE_REACT_APP_YM_LK_CODE = getEnv('VITE_REACT_APP_YM_LK_CODE')

export const reachGoal = ({ goal, params = {} }: IReachGoalProps) => {
  const ym = window?.ym ?? ymClosure

  if (!VITE_REACT_APP_YM_LK_CODE) {
    // eslint-disable-next-line no-console
    console.log('%c[YandexMetrikaDev](GOAL)', 'color: orange', goal, params)

    return
  }

  ym(VITE_REACT_APP_YM_LK_CODE, 'reachGoal', goal, params)
}
